import GatedContentCards from "components/radio-cards/gated-content-cards";
import { ActiveSubscribersTable } from "components/modal/GatedContentModal/ActiveSubscribersTable";
import styles from "./index.module.scss";
import { PricingModalTypes } from "components/modal/GatedContentModal";
import { CatalogGatingFields } from "./useCatalogGating";
import { StringDictionary } from "types";
import { CreatorProductEntitlementsResponse } from "@switcherstudio/switcher-api-client";

export const CatalogPurchaseOptions = ({
    formValues,
    priceErrors,
    handlePriceChange,
    createOrUpdate,
    entitlementAndPrices,
    oneTimePassFeatureEnabled,
    untimedOTPInitiallySelected
}: {
    formValues: CatalogGatingFields;
    priceErrors: StringDictionary;
    handlePriceChange: (key: string, value: any) => void;
    createOrUpdate: PricingModalTypes;
    entitlementAndPrices: CreatorProductEntitlementsResponse;
    oneTimePassFeatureEnabled: boolean;
    untimedOTPInitiallySelected: boolean;
}) => {
    const product = entitlementAndPrices?.ProductEntitlements?.[0]?.Product;
    const productId = entitlementAndPrices?.ProductEntitlements?.[0]?.ProductId;

    if (
        createOrUpdate === PricingModalTypes.Update &&
        (!productId || !product)
    ) {
        return null;
    }

    return (
        <>
            <div className={styles["pass-container"]}>
                <GatedContentCards
                    formValues={formValues}
                    errors={priceErrors}
                    type={createOrUpdate}
                    variant="catalog"
                    onPassChange={handlePriceChange}
                    creatorProductId={productId}
                    shouldShowOneTimePassOption={oneTimePassFeatureEnabled}
                    untimedOTPInitiallySelected={untimedOTPInitiallySelected}
                />
            </div>
            {(productId || product) && (
                <ActiveSubscribersTable creatorProduct={product} />
            )}
        </>
    );
};
